import FormDatePicker from '@/views/components/Inputs/FormDatePicker';
import FormInput from '@/views/components/Inputs/FormInput';
import FormSelectBox from '@/views/components/Inputs/FormSelectBox';
import Paper from '@/views/components/Paper/Paper';
import { Col, Form, Row } from 'antd';

const OriginDetailsGrid = ({
  formTrailerRequestManagement,
  editMode,
  dropdownState,
  requestUserType,
  activeTabName,
}) => {
  const handleFormChangeOrigin = (event) => {
    const { id, value, validity } = event.target;
    const isValidValue = validity.valid ? value : '';
    let parsedVal;
    if (id === 'orgtxtSoftWeight' || id === 'orgtxtMiscWeight' || id === 'orgtxtBookWeight') {
      const val = isValidValue || '0';

      parsedVal = Math.round(Number.parseInt(val) / 23);

      const currentValues = formTrailerRequestManagement.getFieldsValue();

      if (currentValues.orgLocations && currentValues.orgLocations.length > 0) {
        const updatedOrgLocations = [...currentValues.orgLocations];

        if (id === 'orgtxtSoftWeight') {
          updatedOrgLocations[0] = {
            ...updatedOrgLocations[0],
            orgSoftOks: parsedVal,
          };
        } else if (id === 'orgtxtMiscWeight') {
          updatedOrgLocations[0] = {
            ...updatedOrgLocations[0],
            orgMiscOks: parsedVal,
          };
        } else if (id === 'orgtxtBookWeight') {
          updatedOrgLocations[0] = {
            ...updatedOrgLocations[0],
            orgBookOks: parsedVal,
          };
        }

        formTrailerRequestManagement.setFieldsValue({ orgLocations: updatedOrgLocations });
      }
    }
  };
  return (
    <Col xs={48} sm={24}>
      <Paper className="mb-5">
        <div className="card-header p-8">
          <Row gutter={10}>
            <Col sm={4}>
              <span>Origin Details</span>
            </Col>
          </Row>
        </div>

        <div className="card-body">
          <Form.List name="orgLocations">
            {(fields) => (
              <table className="w-100 origindetails">
                <thead>
                  <tr>
                    <th className="background-header text-white fixed fixed-top shadow-none" width="150px">
                      Shipping Location
                    </th>
                    <th className="background-header text-white fixed fixed-top shadow-none" width="120px">
                      Spot Date
                    </th>
                    <th className="background-header text-white fixed fixed-top shadow-none trailer-request-management-fixed-width">
                      ETD
                    </th>
                    <th className="background-header text-white fixed fixed-top shadow-none">Soft Weight</th>
                    <th className="background-header text-white fixed fixed-top shadow-none">Soft OKs</th>
                    <th className="background-header text-white fixed fixed-top shadow-none">Misc Weight</th>
                    <th className="background-header text-white fixed fixed-top shadow-none">Misc OKs</th>
                    <th className="background-header text-white fixed fixed-top shadow-none">Book Weight</th>
                    <th className="background-header text-white fixed fixed-top shadow-none">Book OKs</th>
                    <th className="background-header text-white fixed fixed-top shadow-none">Furn</th>
                    <th className="background-header text-white fixed fixed-top shadow-none">OLI</th>
                  </tr>
                </thead>
                <tbody>
                  {fields.map(({ key, name }) => (
                    <tr key={key}>
                      <td className="center-align">
                        <FormSelectBox
                          editMode={editMode}
                          name={[name, 'orgShipLocation']}
                          margin="m-0"
                          options={dropdownState.partnerLocationOptions}
                          loading={dropdownState.loading.partnerLocations}
                          placeholder="Select Origin Location"
                          labelInValue
                          disabled={activeTabName.includes('Pickup')}
                        />
                      </td>
                      <td className="center-align">
                        <FormDatePicker
                          className="form-control form-control-sm"
                          name={[name, 'orgSpotDate']}
                          margin="m-0"
                        />
                      </td>
                      <td className="center-align">
                        <FormDatePicker name={[name, 'orgETD']} margin="m-0" />
                      </td>
                      <td className="center-align">
                        <FormInput
                          margin="mb-0"
                          type="text"
                          name={[name, 'orgSoftWeight']}
                          id="orgtxtSoftWeight"
                          editMode={editMode}
                          readOnly={requestUserType === 'Store'}
                          onChange={handleFormChangeOrigin}
                          placeholder="Soft Weight"
                        />
                      </td>
                      <td className="center-align">
                        <FormInput
                          margin="mb-0"
                          editMode={editMode}
                          pattern="[0-9]*"
                          type="text"
                          name={[name, 'orgSoftOks']}
                          readOnly
                          id="orgtxtSoftOks"
                          placeholder="Soft OKs"
                        />
                      </td>
                      <td className="center-align">
                        <FormInput
                          margin="mb-0"
                          pattern="[0-9]*"
                          type="text"
                          name={[name, 'orgMiscWeight']}
                          id="orgtxtMiscWeight"
                          onChange={handleFormChangeOrigin}
                          editMode={editMode}
                          placeholder="Misc Weight"
                          readOnly={requestUserType === 'Store'}
                        />
                      </td>
                      <td className="center-align">
                        <FormInput
                          margin="mb-0"
                          pattern="[0-9]*"
                          editMode={editMode}
                          type="text"
                          name={[name, 'orgMiscOks']}
                          readOnly
                          id="orgtxtMiscOks"
                          placeholder="Misc Oks"
                        />
                      </td>
                      <td className="center-align">
                        <FormInput
                          margin="mb-0"
                          pattern="[0-9]*"
                          editMode={editMode}
                          type="text"
                          name={[name, 'orgBookWeight']}
                          id="orgtxtBookWeight"
                          onChange={handleFormChangeOrigin}
                          placeholder="Book Weight"
                          readOnly={requestUserType === 'Store'}
                        />
                      </td>
                      <td className="center-align">
                        <FormInput
                          margin="mb-0"
                          pattern="[0-9]*"
                          editMode={editMode}
                          type="text"
                          name={[name, 'orgBookOks']}
                          readOnly
                          id="orgtxtBookOks"
                          placeholder="Book Oks"
                        />
                      </td>
                      <td className="center-align">
                        <FormInput
                          margin="mb-0"
                          pattern="[0-9]*"
                          editMode={editMode}
                          type="text"
                          name={[name, 'orgFurn']}
                          id="orgtxtFurn"
                          placeholder="Furn"
                          readOnly={requestUserType === 'Store'}
                        />
                      </td>
                      <td className="center-align">
                        <FormInput
                          margin="mb-0"
                          pattern="[0-9]*"
                          type="text"
                          editMode={editMode}
                          name={[name, 'orgOLI']}
                          id="orgtxtOLI"
                          placeholder="OLI"
                          readOnly={requestUserType === 'Store'}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </Form.List>
        </div>
      </Paper>
    </Col>
  );
};

export default OriginDetailsGrid;
